/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Insert_MenuInputs */



/**
* | output |
* | --- |
* | "Insert menu" |
*
* @param {Insert_MenuInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const insert_menu = /** @type {((inputs?: Insert_MenuInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Insert_MenuInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Menu insertion")
	if (locale === "de") return /** @type {LocalizedString} */ ("Menü einfügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci menu")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вставить меню")
	if (locale === "es") return /** @type {LocalizedString} */ ("Menú Insertar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("插入菜单")
	if (locale === "ja") return /** @type {LocalizedString} */ ("挿入メニュー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मेनू डालें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Inserir menu")
	return /** @type {LocalizedString} */ ("Insert menu")
});